import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as _moment from 'moment';
import { Common } from '../../Utility/Common';
//import { EduCalendarService } from 'src/app/Module/Core/EduCalendar/EduCalendar.service';
import { PlanCalendarService } from 'src/app/Module/Core/PlanCalendar/PlanCalendar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../Loader/Loading.service';
import * as moment from 'moment';

@Component({
  selector: 'app-CCalendar',
  templateUrl: './CCalendar.component.html'
})
export class CCalendarComponent implements OnInit {
  @Input() events: any = "";
  @Input() isBeats: any = false;
  
  @Input() selected_section_obj: any = "";
  @Input() holiday_type: any = "";
  @Output() parentref: EventEmitter<any> = new EventEmitter();
  @Output() Submit_Event: EventEmitter<string> = new EventEmitter<string>();

  constructor(private homeapi: PlanCalendarService, private loader: LoadingService, private router: Router) { }
  isAdmin = false;
  salesHospitaltype;
  ngOnInit() {
   
   
    this.CalendarReset();
    this.renderCalendar();
  }

  isSameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth();
  }

  assignmeCalendar(dt){
    //alert('assignedme')
    console.log('dt' , dt);
    this.date = new Date(dt)
    console.log('this.date' , this.date);
    this.currYear = this.date.getFullYear();
    this.currMonth = this.date.getMonth();

    //this.CalendarReset()
      this.renderCalendar();

      console.log('this.json',this._json);
      let _currentdate = this._json.filter((x) => { 

        return this.isSameDay(new Date(x.dt) , this.date);
      })
      console.log('_currentdate', _currentdate);
      if(_currentdate.length > 0){
        //this.ShowEvent(_currentdate[0]);
        this.AssignEvent(_currentdate[0]);
        this.SetCalendar();
      }

  }

  LoadCalendar(event,calinit,salestype,isBeats) {
    //alert('loadcalendar');
    this.isBeats=isBeats;
    this.salesHospitaltype = salestype;
    console.log("salesHospitaltype", salestype);
    console.log("load view", event);
    this.events = event;
    
    if (calinit)
      {
      this.CalendarReset()
      this.renderCalendar();
      }
      else{
       // alert('else')
        //this.renderCalendar();
        this.SetCalendar();
        //this.renderCalendar();
      }
      

    
      }

      SetCalendar(){        

        let workingday = 0;
        if(this.salesHospitaltype == "0" || this.salesHospitaltype == "1")
        {
          workingday = 15; //sales team
        }
        else if(this.salesHospitaltype == "2")
        {
          workingday = 21; //hospital team
        }
	
	

console.log('json', this._json);
        this._json.map((x) => { 
          let _eve = this.CheckEventDays(x.dt);
          x.class = x.class + " " + (_eve.length > 0 ? (_eve[0].class? _eve[0].class: "")  : "")
  
         x.event= _eve

         let _differntDays = this.DifferentDays_v2(x.dt);
         let _startdate = new Date(x.dt);

         if(!this.isBeats){
          console.log("_differntDays x.event[0]", x.event)
          console.log(" _differntDays test", _differntDays)
          if(_differntDays >=0 &&  _differntDays <= workingday)
          {
            if(_startdate.getDay() != 0)
            {
             x.class = x.class.replace("differntDays", " ").replace("dfd_first"," ").replace("dfd_last", " ");

              x.class= x.class + " differntDays " + (_differntDays==0 ? " dfd_first ": "")+ (_differntDays==workingday ? " dfd_last": "");
              
            }else{
              workingday = workingday + 1;
            }
            
          }
         }

        // if(x.event.length>0 && x.event[0]?.is_retail ) {
        //  // console.log(" x.event[0]", x.event[0])
        //   console.log(" x.event[0].is_retail", x.event[0].is_retail)
        // }else{
          
        // }

        })

      }

  GetCurrentMonthview() {
    return { date: this.date, currYear: this.currYear, currMonth: this.currMonth }
  }
  MaximizeView(json) {
    this.date = (json.date);
    this.currYear = json.currYear;
    this.currMonth = json.currMonth;
    console.log("MaximizeView");
    //this.CalendarReset()
    this.renderCalendar();
  }


  CalendarReset() {
    this._event_det_device = false;
    this.date = new Date()
    this.currYear = this.date.getFullYear();
    this.currMonth = this.date.getMonth();
   
  }
  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  date = new Date()
  currYear = this.date.getFullYear();
  currMonth = this.date.getMonth();

  _json = [];
  renderCalendar() {
    // console.log("currMonth", this.currMonth, new Date().getMonth())
    let currYear = this.currYear; let date = this.date;
    let currMonth = this.currMonth;

    let firstDayofMonth = new Date(currYear, currMonth, 0).getDay(), // getting first day of month
      lastDateofMonth = new Date(currYear, currMonth + 1, 0).getDate(), // getting last date of month
      lastDayofMonth = new Date(currYear, currMonth, lastDateofMonth).getDay(), // getting last day of month
      lastDateofLastMonth = new Date(currYear, currMonth, 0).getDate(); // getting last date of previous month
    //let liTag = "";this._json
    this._json = [];
    let _json = this._json;
    //console.log("firstDayofMonth", date)
    let daycnt = 0;
    for (let i = firstDayofMonth+1; i > 0; i--) { // creating li of previous month last days
      //liTag += `<li class="inactive">${lastDateofLastMonth - i + 1}</li>`;
      // let dt=lastDateofLastMonth - i + 1+"/"+
     // _json.push({ class: "inactive", value: lastDateofLastMonth - i + 1, cal_type:1 });
      _json.push({ class: "inactive precaldays ", value: "", cal_type:1 });
      daycnt = daycnt + 1;
    }
    let workingday = 0;
    // if(this.salesHospitaltype == "0" || this.salesHospitaltype == "1")
    // {
    //   workingday = 15; //sales team
    // }
    // else if(this.salesHospitaltype == "2")
    // {
    //   workingday = 22; //hospital team
    // }
    // let _cdate = new Date();
    // if(this.currMonth == _cdate.getMonth() && this.currYear == _cdate.getFullYear())
    //   {
        
    //     this.date = new Date();
    //   }
    for (let i = 1; i <= lastDateofMonth; i++) { // creating li of all days of current month
      // adding active class to li if the current day, month, and year matched
      let _currYear = currYear; let _currMonth = currMonth;
      let dt = _currYear + "/" + (_currMonth + 1) + "/" + i; let cls = "";
      let _startdate = new Date(dt);
      let _isToday = this.isSameDay(new Date() , _startdate);
      let isToday = "";
      if(_isToday){
        isToday = "clstoday ";
        
      }
      // let isToday = i === date.getDate() && currMonth === new Date().getMonth()
      //   && currYear === new Date().getFullYear() ? "clstoday " : "";

      // let _isToday = i === date.getDate() && currMonth === new Date().getMonth()
      // && currYear === new Date().getFullYear() ? true : false;
//console.log('---istodya', _isToday, date.getDate());
      //  liTag += `<li class="${isToday}">${i}</li>`;
      
     
      
      if (_startdate.getDay() == 0) {
        cls = "inactive clsweekend " + isToday;
      } else {
        cls = "active " + isToday;
      }

    

      //  console.log("dt", dt);
      let f_ppdate = _moment(Common.ISO_showNewDate (dt)).format('DD/MM/YY')
      let f_mob_ppdate = _moment(Common.ISO_showNewDate (dt)).format('DD MMM')
      let f_day = _moment(Common.ISO_showNewDate (dt)).format('dddd');
      let _id=f_ppdate.replace(/[/]/g, '')
      let _eve = this.CheckEventDays(dt);

    

      //  console.log("_eve",_eve)
      let _differntDays = this.DifferentDays_v2(dt);
//console.log("_differntDays",_differntDays)
if(_differntDays <0 ){
  cls= cls + " greyDays";
}
      // if(_differntDays >=0 &&  _differntDays <= workingday)
      //   {
      //     if(_startdate.getDay() != 0)
      //     {
      //       cls= cls + " differntDays";
            
      //     }else{
      //       workingday = workingday + 1;
      //     }
          
      //   }
        //console.log('_differntDays', _differntDays);
        
      _json.push({ isToday: _isToday, i:i, differntDays: 0, f_day:f_day, f_mob_ppdate:f_mob_ppdate, id : _id, cal_type:2,class: cls + " " + (_eve.length > 0 ? _eve[0].class : ""), value: i, dt: dt, event: _eve, f_ppdate: f_ppdate , day:_startdate.getDay()})
      
      daycnt = daycnt + 1;
    }
    console.log('json', _json);
    //console.log("daycnt", daycnt)
    // for (let i = 0; i < 42 - daycnt; i++) { // creating li of next month first days
    //   //   liTag += `<li class="inactive">${i - lastDayofMonth + 1}</li>`
    //   _json.push({ cal_type:3, class: "inactive", value: i + 1 })
    // }
    this.currentDate = `${this.months[currMonth]} ${currYear}`; // passing current mon and yr as currentDate text
    //daysTag.innerHTML = liTag;
    //console.log("_json", _json);
  }
  currentDate = "";
  CheckEventDays(dt) {
    let _ch = this.events.filter((y) => { 

      return new Date(dt).toDateString() == new Date(y.calendar_date).toDateString()

    });
    return _ch;
  }

  DifferentDays_v2(date2) {
    // Create a new Date object representing the first date 
      let dt1 = new Date();
    // Create a new Date object representing the second date  
     let dt2 = new Date(date2);
    // Calculate the difference in days between the two datesreturn 
  return  Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
  }

  DifferentDays(dt){
    let diffDays = -1;
    const date1 : any =new Date();
    const date2 : any = new Date(dt);
    
    //date.getDate()
    if(date1 <= date2)
      {
        const diffTime = Math.abs(date2 - date1);
      diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
      }
    
    //console.log(diffTime + " milliseconds");
    //console.log(diffDays + " days");
    return diffDays;
    }

  NextPrev(id) {
    this._event_det_device = false;
    let _date: any = new Date(this.date);
   // console.log("B _date_date", _date)
    if (id == 1) {
      _date = _moment(_date).add(-1, 'months');

    } else {
      _date = _moment(_date).add(1, 'months');
    }
    //console.log("_date_date",_date)
    let _mdate: any = new Date(_date);// this.date;
    this.date = _mdate;
    //console.log("_mdate",_mdate)
    this.currYear = _mdate.getFullYear();
    this.currMonth = _mdate.getMonth();
    // let _cdate = new Date();
    // if(this.currMonth == _cdate.getMonth() && this.currYear == _cdate.getFullYear())
    //   {
        
    //     this.date = new Date();
    //   }
    this.renderCalendar();
    // console.log('-----json----',this._json,)
    // console.log('this.currYear', this.currYear);
    // console.log('this.currMonth', this.currMonth);
    // console.log('id',id);
    

    //this.Submit_Event.emit(id);
    let _currentdate = this._json.filter((x) => { 
      return x.isToday == true;
    })
    
    //console.log('_currentdate', _currentdate);
  if(_currentdate.length > 0){
    this.ShowEvent(_currentdate[0])
  }else{
    let _monthfirstdate = this._json.filter((x) => { 
      if(x.i == 1)// && x.day != 0) //condition removed for sunday next pre error
        {
          return x;
        }
        else if(x.i == 2)// && x.day != 0) //condition removed for sunday next pre error
          {
            return x;
          }
      

    })
    this.ShowEvent(_monthfirstdate[0])
  }
//    this.SetCalendar();

  }
  
  selected_events: any = ""; eventdetail = false; _event_det_device = false;
  jsonstring = "";
  ShowEvent(obj) {
   
    //console.log('day', obj.day);
    //if(obj.day != 0)
      {
       // console.log("obj", obj)
        this._json.map((x) => { 
          x.selectedactive = false;
        })
    
        obj.selectedactive = true; 

        this._event_det_device = false;

        const SubmitLogicFormat = "YYYY-MM-DD";
        let clickedDate = moment(obj.dt).format(SubmitLogicFormat);

        //this.Submit_Event.emit(obj);
       
      this.router.navigate(['/user/plancalendar'], { queryParams: { calenderDate: clickedDate} });
      }
    

    // if (obj.class.indexOf("inactive")) {
    //   let _isdevice: any = Common.isDevice;
    //   this.selected_events = obj;
    //   this.jsonstring = JSON.stringify(this.events);
    //   if (_isdevice) {
    //     this._event_det_device = true;
    //     setTimeout(() => {
    //       //Common.tabfocus_cal_v4(obj.id); 
    //     });
    //   } else {
    //     if (obj.event?.length > 0 && obj.event[0]?.extendedProps?.type == "holiday") {
    //       this.eventdetail = true;
    //     }
    //     else if (this.isAdmin) {
    //       this.state.title.value = ""; this.state.leave_type.value = 0;
    //       this.state.title.iserr = false; this.state.fdate.iserr = false;
    //       this.state.tdate.iserr = false; this.state.leave_type.iserr = false;
    //       this.state.pp_section.iserr = false;
    //       this.isAllSelected = false;
    //      // this.pp_section = Common.JSON_copy(clsRight.GetSection_without_subsection());
    //       this.pp_section.map((x) => { x.isSelected = false; })
    //       //    console.log("this.pp_section", this.pp_section)
    //       this.ppshow = true;
    //       setTimeout(() => {
    //         this.state.fdate.value = new Date(this.selected_events.dt);
    //         this.state.tdate.value = new Date(this.selected_events.dt);
    //       });
    //     }
    //   }

    // }



  }

  AssignEvent(obj) {
   
   // console.log('day', obj);
    //if(obj.day != 0) ////condition removed for sunday next pre error
      {
       // console.log("obj", obj)
        this._json.map((x) => { 
          x.selectedactive = false;
        })
    
        obj.selectedactive = true; 

        this._event_det_device = false;

        const SubmitLogicFormat = "YYYY-MM-DD";
        let clickedDate = moment(obj.dt).format(SubmitLogicFormat);

        
        this.Submit_Event.emit(obj);
        
        
      }
    

    }
  eventclose() {
    this.eventdetail = false;
  }

  ppshow = false;
  close() { this.ppshow = false; }

  state: any = {
    section_list: [],
    sel_Section: { value: 0, iserr: false, err_txt: "" },
    title: { value: "", iserr: false, err_txt: "" },
    leave_type: { value: 0, iserr: false, err_txt: "" },
    notes: { value: "", iserr: false, err_txt: "" },
    leave_cat: { value: 0, iserr: false, err_txt: "" },
    section: { value: 0, iserr: false, err_txt: "" },
    subsection: { value: 0, iserr: false, err_txt: "" },
    fdate: { value: "", iserr: false, err_txt: "" },
    tdate: { min: new Date(new Date().setDate(new Date().getDate() - 30)), value: new Date(), iserr: false, err_txt: "" },
    pp_section: { value: '', iserr: false, err_txt: "" }
  }
  pp_date = "";
  pp_section = []; isAllSelected = false;
  CallAllSection() {
    this.pp_section.map((x) => { this.isAllSelected ? x.isSelected = true : x.isSelected = false; })
  }
  // selsection: any = [];
  // SectionChange() {
  //   //console.log("state.section.value",this.state.section.value) 
  //   this.state.subsection.value = 0;
  //   this.selsection = this._section.filter((y) => { return y.section_id == this.state.section.value })[0];
  //   // console.log("this.selsection ",this.selsection )
  // }
  show_section = false;
  LeaveTypeChange() {
    this.state.section.value = 0;
    this.state.subsection.value = 0;
    if (this.state.leave_cat.value == 1)
      this.show_section = false;
    else
      this.show_section = true;
  }
  Callopen_cal(pic) {
    setTimeout(() => { pic.open() }, 100);
  }
  FdateChange() {
    this.state.tdate.min = this.state.fdate.value;
  }
  async Save() {


    let isvalid = true;
    if (this.state.title.value == "") {
      this.state.title.iserr = true; this.state.title.err_txt = "Enter Title";
      isvalid = false;
    }

    if (this.state.fdate.value == "") {
      this.state.fdate.iserr = true; this.state.fdate.err_txt = "Select Start Date";
      isvalid = false;
    }

    if (this.state.tdate.value == "") {
      this.state.tdate.iserr = true; this.state.tdate.err_txt = "Select End Date";
      isvalid = false;
    }

    if (this.state.leave_type.value == 0) {
      this.state.leave_type.iserr = true; this.state.leave_type.err_txt = "Select Type";
      isvalid = false;
    }

    let _v = this.pp_section.filter((y) => { return y.isSelected }).map((z) => { return z.section_id }).join(",")
    if (_v == "") {
      this.state.pp_section.iserr = true; this.state.pp_section.err_txt = "Select Programs";
      isvalid = false;
    }
    //isvalid=false;
    if (isvalid && this.isAdmin) {
      // let param = {
      //   _title: this.state.title.value, _leave_from_date: _moment(this.state.fdate.value).format('YYYY-MM-DD'),
      //   _leave_to_date: _moment(this.state.tdate.value).format('YYYY-MM-DD'),
      //   // _leave_cat: 1,
      //   _leave_type: parseInt(this.state.leave_type.value),
      //   _section_id: _v
      //   //  _sub_section_id: parseInt(this.state.subsection.value),
      //   //  _data: JSON.stringify({ notes: this.state.notes.value })
      // };
      // console.log("param", param);

      let _data = {
        _leave_from_date: _moment(this.state.fdate.value).format('YYYY-MM-DD'),
        _leave_to_date: _moment(this.state.tdate.value).format('YYYY-MM-DD'),
        section: this.pp_section.filter((y) => { return y.isSelected })
      };

      let param = {
        // _group_id: 0, _mode: 1,
        _group_id: this._mode == 1 ? 0 : this.state.selected_hd.group_id, _mode: this._mode,
        _data: JSON.stringify(_data),
        _title: this.state.title.value, _leave_from_date: _moment(this.state.fdate.value).format('YYYY-MM-DD'),
        _leave_to_date: _moment(this.state.tdate.value).format('YYYY-MM-DD'),
        _leave_type: parseInt(this.state.leave_type.value),
        _section_id: _v
      };
      console.log("param", param)
      this.loader.startLoading();
      await this.homeapi.addCalendar(param, false).then(data => {
        console.log("data", data)
        this.loader.stopLoading();
        if (data.message == "success") {
          this.homeapi.api.Toast_success(this._mode == 1 ? "Successfully Saved" : "Successfully Updated");
          this.Cancel();
          this.ParentRefresh();
          //   this.LoadCalendar();
        }
      });

    }
  }
  _mode = 1;
  AddEditHoliday(obj, id) {
    obj = obj.event[0]?.extendedProps?.data[0];

    this.Cancel();
    //console.log("obj", obj)
    this.state.selected_hd = obj;
    this._mode = id;
    if (id == 2) {
      this.state.title.value = obj.title; this.state.leave_type.value = obj.leave_type;
      this.state.fdate.value = obj.data._leave_from_date;
      this.state.tdate.value = obj.data._leave_to_date;
      //this.pp_section = Common.JSON_copy(clsRight.GetSection_without_subsection());
      this.pp_section.map((x) => {
        let _ff = obj.data.section.filter((y) => { return y.section_id == x.section_id })
        if (_ff.length == 0)
          x.isSelected = false;
        else
          x.isSelected = true;
      })
      this.ppshow = true;
    } else {
      this.DelteHoliday(obj);
    }
  }

  async DelteHoliday(obj){
  }

  Cancel() {
    this.state.selected_hd == "";
    this.ppshow = false; this.eventdetail = false;
    this._mode = 1;
    this.Reset();
  }

  Reset() {
   // this.pp_section = Common.JSON_copy(clsRight.GetSection_without_subsection());
    this.pp_section.map((x) => { x.isSelected = false; })

    this.state.title.value = ""; this.state.leave_type.value = 0;
    this.state.title.iserr = false; this.state.fdate.iserr = false;
    this.state.tdate.iserr = false; this.state.leave_type.iserr = false;
    this.state.pp_section.iserr = false;
    this.isAllSelected = false;
    //this.pp_section = Common.JSON_copy(clsRight.GetSection_without_subsection());
    this.pp_section.map((x) => { x.isSelected = false; })
    console.log("this.pp_section", this.pp_section)
    this.state.fdate.value = ""
    this.state.tdate.value = "";
  }

  ParentRefresh() {

    this.parentref.emit();
  }

  WeekPlanDown(obj){
    console.log("WeekPlanDown",this.selected_section_obj)
    //this.homeapi.api.ShowWeekPlan(this.selected_section_obj.section_id,obj.event[0].week_id,"");
  }
  
  DisplayAddTopSectionCurrentDate(selectedDate){

    const myArray = selectedDate.split(" ");
    let month = myArray[0];
    let year = myArray[1];
    let monthUpper = month.substring(0, 3).toUpperCase();
    //console.log(monthUpper +" "+ year);    
    return monthUpper +" "+ year;

  }

  DisplayAddTopCurrentDate(selectedDate)
  {  
    let addDisplayFormat = "MMM YYYY";
    let displayAddDate = moment(selectedDate).format(addDisplayFormat).toUpperCase()
    return displayAddDate;
    
  }
  DisplayAddTopCurrentDate1(selectedDate)
  {  
    let addDisplayFormat = "MMM YYYY";
    let displayAddDate = moment(selectedDate).format(addDisplayFormat);
    return displayAddDate;
    
  }
  DisplayAddTopCurrentDate2(selectedDate)
  {  
    let addDisplayFormat = "MMM YYYY";
    let displayAddDate = moment(selectedDate).format(addDisplayFormat);
    return selectedDate;
    
  }
}
